import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { isEmailVerified, PROJECT_ACCESS_VERIFICATION_MESSAGE } from '@/utils/emailVerification';

const ProtectedRoute = ({ user, children, requireVerifiedEmail = false }) => {
  const location = useLocation();
  const verificationBlocked = requireVerifiedEmail && !!user && !isEmailVerified(user);

  useEffect(() => {
    // If user is not logged in, save the current URL for redirect after login
    if (!user) {
      const fullPath = location.pathname + location.search + location.hash;
      localStorage.setItem('redirectAfterLogin', fullPath);
    }
  }, [user, location]);

  useEffect(() => {
    if (verificationBlocked) {
      toast.warning(PROJECT_ACCESS_VERIFICATION_MESSAGE);
    }
  }, [verificationBlocked]);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (verificationBlocked) {
    return <Navigate to="/dashboard" replace state={{ verificationRequired: true }} />;
  }

  return children;
};

export default ProtectedRoute;
